// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"8e00d7ba7617a8df","9344":"c0b8703e7d1ef173"}[chunkId] + ".css";
};